const helpers = (props) => {
  let isDateToBeFiltered = false;
  let results = {};
  let fieldsEqual = [{ name: '_templatename', value: 'Promotion Detail' }];

  //in case of or
  if (props?.allFilters?.selectedCategoriesIDForGraphGql.length > 0) {
    fieldsEqual.push({
      name: 'offercategories',
      value: `in:${props?.allFilters?.selectedCategoriesIDForGraphGql}`,
    });
  }

  fieldsEqual.push({
    name: 'validitystart',
    value: `<:${new Date().toISOString()}`, //we start from today date format:2021-12-31T16:00:00Z
  });

  fieldsEqual.push({
    name: 'validityEnd',
    value: `>:${new Date().toISOString()}`, //date format:2021-12-31T16:00:00Z
  });

  let mobileResults = {
    index: props?.indexName,
    language: props?.language,
    fieldsEqual: fieldsEqual,
    after: `0`,
    first: null,
  };
  let DesktopResults = {
    index: props?.indexName,
    language: props?.language,
    first: props?.pagination?.itemsPerPage,
    fieldsEqual: fieldsEqual,
    after: `${
      !!props?.pagination?.currentPage && !!props?.pagination?.itemsPerPage
        ? `${props?.pagination?.itemsPerPage * (props?.pagination?.currentPage - 1)}`
        : '0'
    }`,
  };

  if (props?.isMobile) {
    results = mobileResults; //in mobile results we dont have pagination so we remove the first and after
  } else {
    results = DesktopResults;
  }

  //on filtering
  if (props?.setFilterVariable !== undefined) {
    if (props?.allFilters?.keyword !== '') {
      results.keyword = `${props?.allFilters?.keyword}`;
    } else {
      results.keyword = '';
    }
    props.setFilterVariable(results);
  }
  //on keyword change [handleKeywordChange]
  if (props?.getSearchSuggestions !== undefined) {
    results.sorting = ``; // we dont need sorting when we click search
    if (props?.keyword !== '') {
      results.keyword = `${props?.keyword}`;
    } else {
      results.keyword = '';
    }
    props.getSearchSuggestions({
      variables: {
        ...results,
      },
    });
  }
  //when we click on search [handleKeywordClick]
  if (props?.refetch !== undefined) {
    props.setAllFilters((prev) => {
      return {
        ...prev,
        reRender: !prev.reRender,
        keyword: props?.keyword, //get search keyword to force get the latest state
      };
    });
  }
  let dateFilterLines = 0; //if date is not filtered
  if (isDateToBeFiltered) {
    dateFilterLines = 1; //in case we filter on date we need to remove one because of we have two dates in fieldsEqual
  }

  props.setNumberOfFilters(results?.fieldsEqual?.length - 2 - dateFilterLines - 1);
};

export default helpers;
